module.exports = __webpack_public_path__ + "9de744dc406df0acebe96571b988f8dd.svg";